import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useAppSelector, useAppDispatch } from '../../../hooks/defaultHooks';
import { modalExtra } from '../../../selectors/selectors';
import { closeModal } from '../../../store/slices/modalSlice';
import { isFetchBaseQueryError } from '../../../utils/helpers';
import { useUpdateInvoiceStatusMutation } from '../../invoices/invoices.service';
import cls from './RestoreInvoice.module.scss';

const RerstoreInvoice = () => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const extra = useAppSelector(modalExtra);
  const dispatch = useAppDispatch();
  const [changeInvoiceStatus] = useUpdateInvoiceStatusMutation();
  const closeHandler = (): void => {
    dispatch(closeModal());
  };
  const cancelHandler = async () => {
    setDisabled(true);
    try {
      await changeInvoiceStatus({
        id: extra?.id as string,
        status: 'NEW',
      }).unwrap();
      dispatch(closeModal());
      if (extra?.handler !== undefined) extra.handler();
      toast.success('Invoice successfully restored');
      setDisabled(false);
    } catch (error) {
      setDisabled(false);
      if (isFetchBaseQueryError(error)) {
        if (error.status === 400) {
          toast.error('Please try again later');
        }
      }
    } finally {
      setDisabled(false);
    }
  };
  return (
    <>
      <Modal.Header className={cls.ModalHeader} data-testid="modal-title" closeButton>
        <h3 className="title-3">Change status to Awaiting Payment?</h3>
      </Modal.Header>
      <Modal.Body className={cls.ModalBody}>
        <p>Are you sure you want to change the invoice status to Awaiting Payment?</p>
        <div className={cls.Buttons}>
          <Button
            type="button"
            className="w-100"
            variant="primary"
            disabled={disabled}
            onClick={cancelHandler}
          >
            Change Status
          </Button>
          <Button className="w-100" variant="outline-dark" onClick={closeHandler}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </>
  );
};
export default RerstoreInvoice;
